import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight, Home } from 'lucide-react';

export interface BreadcrumbItem {
  name: string;
  href?: string;
  current?: boolean;
}

interface BreadcrumbNavigationProps {
  items: BreadcrumbItem[];
  /** 是否显示首页图标 */
  showHomeIcon?: boolean;
  /** 额外的CSS类名 */
  className?: string;
}

const BreadcrumbNavigation: React.FC<BreadcrumbNavigationProps> = ({
  items,
  showHomeIcon = true,
  className = '',
}) => {
  return (
    <nav className={`flex items-center space-x-2 text-sm text-gray-500 ${className}`} aria-label="面包屑导航">
      {showHomeIcon && (
        <>
          <Link 
            to="/" 
            className="flex items-center hover:text-blue-600 transition-colors"
            aria-label="返回首页"
          >
            <Home className="w-4 h-4" />
          </Link>
          {items.length > 0 && <ChevronRight className="w-4 h-4" />}
        </>
      )}
      
      {items.map((item, index) => (
        <React.Fragment key={index}>
          {item.href && !item.current ? (
            <Link 
              to={item.href} 
              className="hover:text-blue-600 transition-colors"
            >
              {item.name}
            </Link>
          ) : (
            <span className={item.current ? 'text-gray-900 font-medium' : 'text-gray-500'}>
              {item.name}
            </span>
          )}
          
          {index < items.length - 1 && <ChevronRight className="w-4 h-4" />}
        </React.Fragment>
      ))}
    </nav>
  );
};

export default BreadcrumbNavigation;